import { graphql } from "@/graphql/generated/gql";

export const getLabelListForWorkspaceQueryDocument = graphql(/* GraphQL */ `
  query GetLabelListForWorkspace($input: GetLabelListForWorkspaceInput!) {
    labelListForWorkspace(getLabelListForWorkspaceInput: $input) {
      ...LabelFields
      instanceList {
        ...LabelInstanceFields
      }
    }
  }
`);

export const getLabelQueryDocument = graphql(/* GraphQL */ `
  query GetLabel($input: GetLabelInput!) {
    label(getLabelInput: $input) {
      ...LabelFields
      instanceList {
        ...LabelInstanceFields
      }
    }
  }
`);

export const createLabelMutationDocument = graphql(/* GraphQL */ `
  mutation createLabel($input: CreateLabelInput!) {
    createLabel(createLabelInput: $input) {
      ...LabelFields
      instanceList {
        ...LabelInstanceFields
      }
    }
  }
`);

export const updateLabelMutationDocument = graphql(/* GraphQL */ `
  mutation UpdateLabel($input: UpdateLabelInput!) {
    updateLabel(updateLabelInput: $input) {
      ...LabelFields
      instanceList {
        ...LabelInstanceFields
      }
    }
  }
`);

export const deleteLabelMutationDocument = graphql(/* GraphQL */ `
  mutation DeleteLabel($input: DeleteLabelInput!) {
    deleteLabel(deleteLabelInput: $input) {
      ...LabelFields
      instanceList {
        ...LabelInstanceFields
      }
    }
  }
`);
